import { useBooleanFlagValue } from '@openfeature/react-sdk';
import type { FeatureFlagDefinition } from '@/config/feature-flags';

/**
 * Evaluate a boolean feature flag from the typed registry.
 * Returns the flag's `defaultValue` until the provider is READY or if Flagsmith is unreachable.
 *
 *   const showDesignSystem = useFeatureFlag(FLAGS.designSystemPage);
 */
export function useFeatureFlag(flag: FeatureFlagDefinition): boolean {
  return useBooleanFlagValue(flag.key, flag.defaultValue);
}
